(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vonn-design"] && !Shopify.designMode) return;
  try {
    function initVonn(scope=document){
 scope.querySelectorAll('[data-marquee]').forEach(el=>{if(el.dataset.ready)return;el.dataset.ready='true';const btn=el.querySelector('button');btn.addEventListener('click',()=>{const paused=el.toggleAttribute('data-paused');btn.setAttribute('aria-pressed',String(paused));btn.setAttribute('aria-label',paused?'Reprendre le défilement':'Mettre le défilement en pause');btn.textContent=paused?'▶':'Ⅱ';});});
 scope.querySelectorAll('[data-offers]').forEach(el=>{if(el.dataset.ready)return;el.dataset.ready='true';const track=el.querySelector('.vn-offer-track'),cards=[...track.children],tabs=[...el.querySelectorAll('[data-offer-index]')];const set=(index)=>tabs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));tabs.forEach((button,index)=>button.addEventListener('click',()=>{track.scrollTo({left:cards[index].offsetLeft-cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});set(index);}));let pending=false;track.addEventListener('scroll',()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{const left=track.getBoundingClientRect().left;let nearest=0,min=Infinity;cards.forEach((card,i)=>{const d=Math.abs(card.getBoundingClientRect().left-left);if(d<min){min=d;nearest=i;}});set(nearest);pending=false;});},{passive:true});});
}
initVonn();document.addEventListener('shopify:section:load',event=>initVonn(event.target));
document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.vn-offer');if(card){const track=card.parentElement;track.scrollTo({left:card.offsetLeft-track.children[0].offsetLeft,behavior:'instant'});}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vonn-rating-design"] && !Shopify.designMode) return;
  try {
    (()=>{
 const media=matchMedia('(prefers-reduced-motion: reduce)');
 let observer;
 const createObserver=()=>new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('vr-reveal-once');observer.unobserve(entry.target);}});},{threshold:.08});
 const init=(scope=document)=>{if(media.matches||!('IntersectionObserver' in window))return;if(!observer)observer=createObserver();scope.querySelectorAll('.vn-rating [data-vr-reveal]').forEach(el=>{if(!el.classList.contains('vr-reveal-once'))observer.observe(el);});};
 init();
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>{event.target.querySelectorAll('[data-vr-reveal]').forEach(el=>observer?.unobserve(el));});
 media.addEventListener('change',()=>{observer?.disconnect();observer=undefined;if(!media.matches)init();});
})();
  } catch(e) { console.error(e); }
})();

})();
